module.exports = __webpack_public_path__ + "static/media/rest.a56160b6.png";